import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';
import { CerberusStatsFields } from '@hcs/types';

import { CerberusStatsListingStatsChart } from '../../components/CerberusStatsListingStatsChart';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants/marketInsights.constants';
import { useMsaListingStatsTimeSeries } from '../../hooks/useMsaListingStatsTimeSeries';
import { getIsRentalListingStatsField } from '../../utils/cerberusStatsConfig.utils';

interface MsaListingStatsLineChartProps {
  className?: string;
  msaId: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  cerberusStatsField: CerberusStatsFields;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const MsaListingStatsChart = ({
  className,
  msaId,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  cerberusStatsField,
  theme,
}: MsaListingStatsLineChartProps) => {
  const dataHcName = `msa-${cerberusStatsField}-chart`;
  const { data, isLoading } = useMsaListingStatsTimeSeries({
    msaId,
    fromDate,
    toDate,
  });
  const isRentalField = getIsRentalListingStatsField(cerberusStatsField);

  return (
    <CerberusStatsListingStatsChart
      dataHcName={dataHcName}
      className={className}
      theme={theme}
      cerberusStatsField={cerberusStatsField}
      isRentalField={isRentalField}
      isLoading={isLoading}
      data={isRentalField ? data?.rentalListingStats : data?.saleListingStats}
    />
  );
};
